import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartSankey } from './useGetChartSankey'
import { ChartSankeyContent } from './ChartSankeyContent'

export const ChartSankeyComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartSankey(id, tileFilterSelections)

  return (
    <ChartSankeyContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartSankeyComponentLoading() {
  return 'Loading...'
}
